import CloudinaryImage from 'components/CloudinaryImage'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
export const BasicHedgehogImage = () => <CloudinaryImage width={300} src="https://res.cloudinary.com/dmukukwp6/image/upload/posthog.com/src/images/lost-hog.png" />
